(function(){
  var ProductCardCarousel = class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const prevArrow = this.closest('.product-card__figure').querySelector('.prev-next-button--prev');
      const nextArrow = this.closest('.product-card__figure').querySelector('.prev-next-button--next');
      $(this).slick({ arrows: true, infinite: false, responsive: [{ breakpoint: 768, settings: { dots: true, arrows: false }}], prevArrow, nextArrow });
      this.closest('a.product-card__media').addEventListener('click', e => {
        if (e.target.classList.contains('slick-arrow')) e.preventDefault();
      })
    }
  }

  if (!window.customElements.get("product-card-carousel")) {
    window.customElements.define("product-card-carousel", ProductCardCarousel);
  }  

  var DragScroll = class {
    constructor(node) {
      this.node = node;
      this.initListeners();
    }

    initListeners() {
      this.node.querySelectorAll('img').forEach(img => img.addEventListener('dragstart', e => e.preventDefault()));

      this.node.addEventListener('mousedown', this.onMouseDown.bind(this));
      this.node.addEventListener('mouseup', this.onMouseUp.bind(this));
      this.node.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.node.addEventListener('mousemove', this.onMouseMove.bind(this));
    }

    onMouseDown(event) {
      this.isDown = true;
      this.startX = event.pageX - this.node.offsetLeft;
      this.startY = event.pageY - this.node.offsetTop;
      this.scrollLeft = this.node.scrollLeft;
      this.scrollTop = this.node.scrollTop; 
    }

    onMouseUp(event) {
      this.isDown = false;
    }

    onMouseLeave(event) {
      this.isDown = false;
    }

    onMouseMove(event) {
      if (!this.isDown) return;

      event.preventDefault();

      const x = event.pageX - this.node.offsetLeft;
      const walkX = x - this.startX;
      this.node.scrollLeft = this.scrollLeft - walkX;

      const y = event.pageY - this.node.offsetTop;
      const walkY = y - this.startY;
      this.node.scrollTop = this.scrollTop - walkY;
    }
  }

  var PopupDisclosure = class {
    constructor(node) {
      this.node = node;
      this.initListeners();
    }

    initListeners() {
      this.node.addEventListener('mousedown', this.onMouseDown.bind(this));
      this.node.addEventListener('mouseup', this.onMouseUp.bind(this));
      this.node.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.node.addEventListener('mousemove', this.onMouseMove.bind(this));
    }

    onMouseDown(event) {
      this.isClick = true;
      this.startX = event.pageX - this.node.offsetLeft;
      this.startY = event.pageY - this.node.offsetTop;
      this.scrollLeft = this.node.scrollLeft;
      this.scrollTop = this.node.scrollTop; 
    }

    onMouseUp(event) {
      if (this.isClick) {
        document.querySelector(this.node.dataset.container).classList.toggle('active');
      }
      this.isClick = false;
    }

    onMouseLeave(event) {
      this.isClick = false;
    }

    onMouseMove(event) {
      if (!this.isClick) return;

      event.preventDefault();

      const x = event.pageX - this.node.offsetLeft;
      const walkX = x - this.startX;

      const y = event.pageY - this.node.offsetTop;
      const walkY = y - this.startY;

      if (Math.abs(walkX) > 5 || Math.abs(walkY) > 5) {
        this.isClick = false;
      }
    }
  }

  var ShopifyProductForm = class {
    constructor(node) {
      this.node = node;
      
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.id === 'bcpo') {
              new VariantPicker(node);
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  var VariantPicker = class {
    constructor(node) {
      this.node = node;
      this.select = this.node.querySelector('#bcpo-select');
      this.labels = Array.from(this.node.querySelectorAll('.bcpo-front-button-label'));
      this.product = fetch(`${window.location.pathname}.json`).then(res => res.json());
      this.initListeners();
    }

    initListeners() {
      console.log(this.node)
      this.select.addEventListener('change', this.onSelectChange.bind(this));
      // this.labels.forEach(l => l.addEventListener('mouseover', this.onMouseOver.bind(this)));
      // this.labels.forEach(l => l.addEventListener('mouseleave', this.onMouseLeave.bind(this)));
    }

    async onSelectChange(event) {
      console.log(event.target);
    }

    async onMouseOver(event) {
      // const option = event.target.innerText.trim();
      // const product = await this.product;
      // const inventoryQuantity = product.variants.find(v => v.option1 == option)?.
    }

    async onMouseLeave(event) {
      // console.log("leave", this)
      // var product = await this.product;
      // console.log("leave", product)
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('.drag-scroll')).forEach(s => new DragScroll(s));
    Array.from(document.querySelectorAll('.popup-disclosure')).forEach(s => new PopupDisclosure(s));
    // Array.from(document.querySelectorAll('.shopify-product-form')).forEach(s => new ShopifyProductForm(s));
  });
})();